import { useApiEffect } from 'framework/hooks/useApiEffect';
import { useLazyEffect } from 'framework/hooks/useLazyEffect';
import { useTrigger } from 'framework/hooks/useTrigger';
import { IRouteParamsWithId } from 'framework/router/IRouteParamsWithId';
import { repairsQuery_single } from 'gen/ApiClient';
import React from 'react';
import { useParams } from 'react-router-dom';
import { RestrictedPageX } from 'shared/layout/RestrictedPageX';
import { RepairDetailPageHeader } from './RepairDetailPageHeader';
import { RepairDetailPageSidebar } from './RepairDetailPageSidebar';
import { RepairDetailContentsCard } from './RepairDetailContentsCard';
import { RepairDetailDocumentsCard } from './RepairDetailDocumentsCard';

export const RepairDetailPage = () => {
	const { id } = useParams<IRouteParamsWithId>();
	const [trigger, reload] = useTrigger();
	const [item, reloadDetail] = useApiEffect(repairsQuery_single, id);

	useLazyEffect(() => {
		reloadDetail();
	}, [trigger]);

	if (item === undefined) {
		return <div></div>;
	}

	return (
		<RestrictedPageX
			pageClaim='Orders'
			stickyHeader={
				<RepairDetailPageHeader
					item={item}
					reload={reload}
				/>
			}
			stickySidebar={
				<RepairDetailPageSidebar
					item={item}
					reload={reload}
				/>
			}>
			<div
				className='df-col gap-16'
				style={{
					padding: 16,
					paddingLeft: 8,
					maxWidth: 1280,
				}}>
				<div className='df-row-wrap gap-16'>
					<RepairDetailContentsCard
						item={item}
						reload={reload}
						style={{ flexGrow: 2 }}
						className='h-fc'
						reloadTrigger={trigger}
					/>
					<div
						className='df-col gap-16'
						style={{ flexGrow: 1 }}>
						{/* <RepairDetailDeliveriesCard
							item={item}
							reload={reload}
						/> */}
						<RepairDetailDocumentsCard
							item={item}
							reload={reload}
							reloadTrigger={trigger}
						/>
					</div>
				</div>
			</div>
		</RestrictedPageX>
	);
};
